import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { clsx } from 'clsx';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  host: { '[class]': 'hostClasses()' },
})
export class DashboardComponent {
  hostClasses = computed(() => clsx('block h-full overflow-x-hidden overflow-y-auto'));
}
